import React from 'react';
import Icon from 'presentation/icons';
import {useTheme} from '@mui/material';
import {ButtonActionCalendar, Container} from './styles';
import {DatePickerHeaderProps} from '../../DatePickerHeader.types';

const DatePickerHeaderDesktop: React.FC<DatePickerHeaderProps> = ({
	onPrevMonth,
	onNextMonth,
	disableButtonPrevMonth,
	disableButtonNextMonth,
}) => {
	const {colors} = useTheme();
	return (
		<Container>
			<ButtonActionCalendar
				type="button"
				onClick={onPrevMonth}
				disabled={disableButtonPrevMonth}>
				<Icon name="arrow-left-filled" color={colors.brand.primary.blue} />
			</ButtonActionCalendar>
			<ButtonActionCalendar
				type="button"
				onClick={onNextMonth}
				disabled={disableButtonNextMonth}>
				<Icon name="arrow-right-filled" color={colors.brand.primary.blue} />
			</ButtonActionCalendar>
		</Container>
	);
};

export {DatePickerHeaderDesktop};
